import { TextStyled } from '@procurify/ui'
import styled from 'styled-components'

export const TaxLabelTextStyled = styled.div`
  ${TextStyled} {
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }
`
